import React, { Component } from 'react'
import { Link } from 'react-router-dom'

import LabelledText from '../App/LabelledText'

class OtherProject extends Component {
  render () {
    const p = this.props.project

    console.log('p', p)

    const federalRiding = p ? p.federalRiding() : null
    const provincialRiding = p ? p.provincialRiding() : null

    return (
      <div className='OtherProject'>
        <h1>{p && p.name}</h1>
        {p &&
          <div>
            <LabelledText
              label={'Project type'}
              text={
                <span>
                  <i className={p.icon} />&nbsp;
                  {p.typeShortName}
                </span>
              }
            />
            {p.owner && <LabelledText label={'Owner'} text={p.owner} />}
            {p.operator && <LabelledText label={'Operator'} text={p.operator} />}
            {p.technology && <LabelledText label={'Technology'} text={p.technology} />}
            {p.website && <LabelledText label={'Website'} target='_blank' text={<a href={p.website}>{p.website}</a>} />}
            <LabelledText label={'Location'} text={`${p.city}, ${p.province}`} />
            <LabelledText label={'Latitude / Longitude'} text={`${p.lat}, ${p.lon}`} />
          </div>
        }
        <div>
          {federalRiding &&
            <div>
              <h2>Federal riding</h2>
              <p className='lead'>
                <Link to={federalRiding.URL()}>{federalRiding.name}</Link>
              </p>
            </div>
          }
          {provincialRiding &&
            <div>
              <h2>Provincial riding</h2>
              <p className='lead'>
                <Link to={provincialRiding.URL()}>{provincialRiding.name}</Link>
              </p>
            </div>
          }
        </div>
      </div>
    )
  }
}

export default OtherProject



// WEBPACK FOOTER //
// ./src/components/Projects/OtherProject.js